import React from "react";
import { RouteComponentProps, withRouter } from "react-router-dom";

import { EnterpriseGrid } from "@pollyslack/hub/src/types";

import { DocumentTabNav } from "../../components/DocumentTabNav";
import MenuBar from "../../components/MenuBar";
import { info } from "../../services/api/Enterprise";

import { EnterpriseTab } from "./tabs/EnterpriseTab";
import { OrganizationsTab } from "./tabs/OrganizationsTab";
import { Spinner } from "reactstrap";

interface GridPageContentState {
  grid?: EnterpriseGrid;
  currentTab: "enterprise" | "organizations";
  isLoading: boolean;
}

class GridPageContent extends React.Component<
  RouteComponentProps<{ gridId: string }>,
  GridPageContentState
> {
  constructor(props: any) {
    super(props);
    this.state = {
      grid: undefined,
      currentTab: "enterprise",
      isLoading: false,
    };
  }

  componentDidMount() {
    this.loadGrid();
  }

  reload = async () => {
    await this.loadGrid();
  };

  async loadGrid() {
    try {
      this.setState({ isLoading: true });
      const response = await info(this.props.match.params.gridId);
      this.setState({ grid: response });
    } catch (e) {
      alert("Error: " + e);
    } finally {
      this.setState({ isLoading: false });
    }
  }

  public render() {
    const tabs = [
      {
        id: "enterprise",
        label: "Enterprise",
        onClick: () => this.setState({ currentTab: "enterprise" }),
      },
      {
        id: "organizations",
        label: "Organizations",
        onClick: () => this.setState({ currentTab: "organizations" }),
      },
    ];

    return (
      <div>
        <MenuBar />
        <div className="p-4">
          <h1>Enterprise Grid Info</h1>
          <DocumentTabNav initialTab="enterprise" tabs={tabs} />
          <div className="mt-4">
            {this.state.currentTab === "enterprise" && (
              <>
                {this.state.isLoading && (
                  <div className="d-flex justify-content-center align-items-center pt-5">
                    <Spinner style={{ width: "3rem", height: "3rem" }} />
                    <div className="pl-2" style={{ fontSize: "2rem" }}>
                      Loading...
                    </div>
                  </div>
                )}
                {this.state.grid && (
                  <EnterpriseTab grid={this.state.grid} reload={this.reload} />
                )}
              </>
            )}
            {this.state.grid && this.state.currentTab === "organizations" && (
              <OrganizationsTab grid={this.state.grid} reload={this.reload} />
            )}
          </div>
        </div>
      </div>
    );
  }
}

export const GridPage = withRouter(GridPageContent);
